import { lazy } from 'react';
import { authModules } from 'app/auth';
import ABSUtils from '@abs/utils/ABSUtils';
import themesConfig from 'app/configs/themesConfig';

const Vehicles = lazy(() => import('./Vehicles'));

const VehiclesConfig = {
    settings: {
        layout: {
            config: {}
        },
        theme: {
            main: ABSUtils.IsDarkMode() ? themesConfig.exkursioDark : themesConfig.exkursio,
            navbar: ABSUtils.IsDarkMode() ? themesConfig.exkursioDark : themesConfig.exkursio,
        }
    },
    routes: [
        {
            path: '/eo/vehicles',
            element: <Vehicles />,
            auth: authModules.eo_default
        }
    ]
};

export default VehiclesConfig;
